export enum VToastTypes {
  'SUCCESS' = 'success',
  'WARNING' = 'warning',
  'ERROR' = 'error',
}

export const VToastTypesList = {
  0: VToastTypes.SUCCESS,
  1: VToastTypes.ERROR,
  2: VToastTypes.WARNING,
}

export type VToastOptions = {
  content: string
  type?: VToastTypes
  title?: string
  lifeTime?: number
  link?: string
}

export type VToastItem = {
  id: string
  type: VToastTypes
  title: string
  lifeTime: number
  content: string
  link: string
}
